import React from 'react';
import type { DashboardModel } from '../../hooks/useDashboard';
import DashboardMapOverlay from './DashboardMapOverlay';
import DashboardMapHud from './DashboardMapHud';

const DashboardMapPanel: React.FC<DashboardModel> = (model) => {
  const { dark, mapContainerRef } = model;

  return (
    <section className={`relative h-full ${dark ? '' : 'xl:col-span-3'}`}>
      <div className={`h-full relative overflow-hidden group ${dark ? 'rounded-[2rem] border border-white/10 bg-slate-900 shadow-[0_40px_120px_rgba(2,6,23,0.85)]' : 'rounded-[2rem] border border-slate-200/70 shadow-[0_8px_40px_rgba(15,23,42,0.12)] bg-white'}`}>
        <div ref={mapContainerRef} className={`absolute inset-0 z-0 ${dark ? 'bg-slate-950' : 'bg-slate-100'}`} />
        <DashboardMapOverlay {...model} />
        <DashboardMapHud {...model} />
      </div>
    </section>
  );
};

export default DashboardMapPanel;
